import React from "react";
import { Icon } from "semantic-ui-react";

import styles from "./TopProducts.module.scss";

function formatCurrency(value) {
  return `Q${Number(value || 0).toLocaleString("es-GT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function TopProducts({ products = [], isLoading = false, onViewAll }) {
  return (
    <section className={styles.TopProducts}>
      <header className={styles.Header}>
        <div>
          <h2>Productos con más existencias</h2>
          <p>Variantes con mayor stock disponible en este momento.</p>
        </div>

        <button type="button" className={styles.ViewButton} onClick={onViewAll}>
          Ver productos
          <Icon name="angle right" />
        </button>
      </header>

      {isLoading ? (
        <div className={styles.EmptyState}>
          <span>Cargando...</span>
        </div>
      ) : products.length === 0 ? (
        <div className={styles.EmptyState}>
          <Icon name="box" />
          <span>Todavía no hay existencias registradas.</span>
        </div>
      ) : (
        <div className={styles.ProductList}>
          {products.map((product) => (
            <article key={product.id} className={styles.ProductItem}>
              <span
                className={`${styles.Position} ${
                  product.position <= 3 ? styles.PositionTop : ""
                }`}
              >
                {product.position}
              </span>

              <div className={styles.ImageContainer}>
                {product.image ? (
                  <img
                    src={product.image}
                    alt={product.name}
                    className={styles.ProductImage}
                  />
                ) : (
                  <div className={styles.ImagePlaceholder}>
                    <Icon name="image outline" />
                  </div>
                )}
              </div>

              <div className={styles.ProductInfo}>
                <p className={styles.ProductName}>{product.name}</p>
                <span className={styles.Sku}>{product.sku}</span>
              </div>

              <div className={styles.ProductMetrics}>
                <strong>{product.stock}</strong>
                <span>en stock</span>
              </div>

              <div className={styles.ProductRevenue}>
                <strong>{formatCurrency(product.value)}</strong>
                <span>en catálogo</span>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
